import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { generateQueryString } from '../../../utils/queryKey';
import {
  ISellerDashboardCardsResponse,
  ISellerDashboardAnalyticsCardsResponse,
  ISellerDashboardBestSellerProductsResponse,
  ISellerDashboardCustomerInsightResponse,
  ISellerDashboardPurchaseDemographicsResponse,
  ISellerDashboardQueryParams,
  ISellerDashboardSalesPeakResponse,
  ISellerDashboardSalesPerformanceResponse,
  ISellerDashboardStoreRatingResponse,
  ISellerDashboardRecentOrdersResponse,
} from './interface';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getSellerDashboardCards: builder.query<ISellerDashboardCardsResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/dashboard-cards?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardAnalyticsCards: builder.query<ISellerDashboardAnalyticsCardsResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/analytics-cards?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardSalesPerformance: builder.query<ISellerDashboardSalesPerformanceResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/sales-performance?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardBestSellerProducts: builder.query<ISellerDashboardBestSellerProductsResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/best-seller-products?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardSalesPeak: builder.query<ISellerDashboardSalesPeakResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/sales-peak?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardPurchaseDemographics: builder.query<ISellerDashboardPurchaseDemographicsResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/purchase-demographics?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardStoreRating: builder.query<ISellerDashboardStoreRatingResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/store-rating?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

    getSellerDashboardCustomerInsight: builder.query<ISellerDashboardCustomerInsightResponse, ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/customer-insight?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),

        getSellerDashboardRecentOrders: builder.query<ISellerDashboardRecentOrdersResponse[], ISellerDashboardQueryParams>({
      query: (params) => ({
        url: `/seller/dashboard/recent-orders?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetSellerDashboardCardsQuery,
  useGetSellerDashboardAnalyticsCardsQuery,
  useGetSellerDashboardSalesPerformanceQuery,
  useGetSellerDashboardBestSellerProductsQuery,
  useGetSellerDashboardSalesPeakQuery,
  useGetSellerDashboardPurchaseDemographicsQuery,
  useGetSellerDashboardStoreRatingQuery,
  useGetSellerDashboardCustomerInsightQuery,
  useGetSellerDashboardRecentOrdersQuery,
} = dashboardApi;
